<template lang='html'>
  <div class='agency-locations'>
        <agency-location v-for="location in locations" :location="location" :key="location.id" :countries="countries" @locationDeleted="deleteLocation"></agency-location>
        <div class="align-center">
            <button type="button" class='big-purple-button' @click="addItem">Add more</button>
        </div>
  </div>
</template>

<script>
// Component for showing locations form

export default {
  props: ['default', 'countries'],
  data() {
    return {
      locations: [],
      lastIndex: 0
    };
  },
  methods: {
    addItem() {
      this.lastIndex += 1;
      this.locations.push({
        id: this.lastIndex
      });
    },
    deleteLocation(removedLocation) {
      this.locations = this.locations.filter((location) => {
        if (location.id !== removedLocation.id) return true;
      });
    }
  },
  created() {
    if (!this.default) {
      this.addItem();
    } else {
      this.default.forEach((location) => {
        this.locations.push(location);
        if (+location.id > this.lastIndex) this.lastIndex = +location.id;
      });
    }
  }
};
</script>